import { routenames } from '@/router/routenames';
import type { NavigationEntryRaw } from '../types';

export const licensesNavigationRaw: NavigationEntryRaw[] = [
  {
    titleI18n: 'License_other',
    route: { name: routenames.licenses },
  },
];
